import React from 'react';

import { useIntl } from 'react-intl';

import Button from '@atlaskit/button/new';

import { BaseEmptyState, illustrationStyle } from './base-empty-state.tsx';
import messages from './messages.ts';
import { NoStarredAgentsIllustration } from './no-starred.illustration.tsx';

export type NoStarredAgentsEmptyStateProps = {
	onSeeAllAgentsClick?: (
		analyticsEvent: Parameters<NonNullable<React.ComponentProps<typeof Button>['onClick']>>[1],
	) => void;
	singleColumn?: boolean;
};

export const NoStarredAgentsEmptyState = ({
	onSeeAllAgentsClick,
	singleColumn,
}: NoStarredAgentsEmptyStateProps): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<BaseEmptyState
			singleColumn={singleColumn}
			illustration={
				// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values
				<NoStarredAgentsIllustration style={illustrationStyle} />
			}
			heading={formatMessage(messages.noStarredAgentsHeader)}
			description={formatMessage(messages.noStarredAgents)}
			cta={
				onSeeAllAgentsClick && (
					<Button
						appearance="primary"
						onClick={(_, analyticsEvent) => onSeeAllAgentsClick(analyticsEvent)}
					>
						{formatMessage(messages.seeAllAgentsButton)}
					</Button>
				)
			}
		/>
	);
};
